import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import ListStatisticsEndUser from './ListStatisticsEndUser'

const EndUserStatisticsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListStatisticsEndUser /></PrivateRoute7>} />
    </Routes>
  )
}

export default EndUserStatisticsRoutes